exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fct-horizontal-adapt-layout{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:start;align-items:flex-start;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.fct-horizontal-adapt-layout>.layout-item{-ms-flex-negative:0;flex-shrink:0}.fct-horizontal-adapt-layout>.layout-item.layout-full-item{-ms-flex-positive:1;flex-grow:1}.fct-horizontal-adapt-layout._stretch{-ms-flex-align:stretch;align-items:stretch}.fct-horizontal-adapt-layout._middle{-ms-flex-align:center;align-items:center}.fct-horizontal-adapt-layout._bottom{-ms-flex-align:end;align-items:flex-end}.fct-horizontal-adapt-layout>*{position:relative;-ms-flex-negative:0;flex-shrink:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/less-loader!./layout/adapt/HorizontalAdaptLayout.less
// module id = 168
// module chunks = 0